import {alphas, brandColor, greys, greysDark} from '../../styles/colorStyles';
import {darkBackgroundSemanticStyles, lightBackgroundSemanticStyles} from './backgroundSemanticStyles';
import {lightIconSemanticStyles} from './iconSemanticStyles';

export interface TopBarSemanticStyles {
  background: string;
  buttonColor: string;
  buttonHoverColor: string;
  buttonSelectedColor: string;
  buttonHoverBackground: string;
  buttonSelectedBackground: string;
  buttonDisabledColor: string;
  availabilityIconColor: string;
}

// Styles which are shared between the dark and light themes. Most of the top
// bar does not change appearance between the themes.
export const sharedTopBarSemanticStyles = {
  background: brandColor,

  buttonColor: alphas.white40,
  buttonHoverColor: alphas.white50,
  buttonHoverBackground: alphas.white20,
  buttonSelectedColor: greys.shade10,
  buttonSelectedBackground: alphas.gray20,
  buttonDisabledColor: alphas.white30,
  availabilityIconColor: greys.white,
} as const satisfies TopBarSemanticStyles;

export const redesignedLightTopBarSemanticStyles: TopBarSemanticStyles = {
  background: greys.shade20,
  buttonColor: greys.shade70,
  buttonHoverColor: greys.shade80,
  buttonSelectedColor: lightIconSemanticStyles.primary,
  buttonHoverBackground: lightBackgroundSemanticStyles.fill.tertiaryHover,
  buttonSelectedBackground: lightBackgroundSemanticStyles.fill.tertiaryHover,
  buttonDisabledColor: greys.shade50,
  availabilityIconColor: greys.white,
} as const satisfies TopBarSemanticStyles;

export const redesignedDarkTopBarSemanticStyles: TopBarSemanticStyles = {
  background: greysDark.shade10,
  buttonColor: greysDark.shade80,
  buttonHoverColor: greysDark.shade80,
  buttonSelectedColor: greysDark.shade70,
  buttonHoverBackground: darkBackgroundSemanticStyles.fill.tertiaryHover,
  buttonSelectedBackground: darkBackgroundSemanticStyles.fill.tertiaryHover,
  buttonDisabledColor: greysDark.shade50,
  availabilityIconColor: greys.white,
} as const satisfies TopBarSemanticStyles;
